import React, { useEffect, useState } from 'react';
import BaseLayout from 'Components/Layout/BaseLayout';
import Breedcumb from 'Components/Breedcumb/Breedcumb';
import axiosInstance from 'Utils/Interceptor';
import DoneIcon from 'Assets/Icons/DoneIcon.png';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
function ThankYou() {
  const [blogs, setBlogs] = useState([]);
  const [value, setValue] = useState(0);
  const location = useLocation();

  return (
    <BaseLayout _class="header-top-offset booking-process-header my-booking-details-page my-booking-main-page">
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_URL}${location.pathname}`}
        />
        <title>Thank You</title>
        <meta
          name="keywords"
          content=""
        />
        <meta
          name="description"
          content="Thank You"
        />
      </Helmet>
      <section className="test-listing-section pb-0 pt-0 tag-interchange">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="thankyou-heading">
                <img
                  alt="Thank You"
                  className=""
                  src={DoneIcon}
                />
                <h1>Thank You</h1>
                <p>
                  Your request has been sent successfully
                  <br />
                  We will get back to you soon
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
}

export default ThankYou;
